import { Box, Heading, mediaQueries, style } from '@do/walrus';
import { useMemo } from 'react';
import styled from 'styled-components';
import { GetSaasAppBySlug_GetSaasAppBySlug_app_plans_features as SaasPlanFeatures } from '../../graphql/generated-types/GetSaasAppBySlug';
import copy from '../copy';

const FeatureListElement = styled.ul`
  list-style: none;
  background: white;
  padding: 0 ${style.vars.space['3']};
  border: 1px solid ${style.colors.grey.light};
  border-radius: ${style.vars.borderRadius.base};

  ${mediaQueries.smallMax} {
    margin: ${style.vars.space['3']} 0;
  }
`;

const FeatureListItemWrapper = styled.li<{ $enabled?: boolean }>`
  color: ${({ $enabled }) => !$enabled && style.colors.grey.primary};
  padding: ${style.vars.space['2']} 0;

  &:not(:first-child) {
    border-top: 1px solid ${style.colors.grey.light};
  }
`;

const FeatureListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${style.vars.space['2']} 0;
`;

const FeatureListItemName = styled.p`
  font-weight: ${style.vars.fontWeight.bold};
  color: ${style.colors.grey.darkest};
  margin: 0;
`;

const FeatureListItemValue = styled.p`
  color: ${style.colors.grey.dark};
  margin: 0;
`;

interface Props {
  planFeatures: SaasPlanFeatures[] | null;
}

const formatFeatureValues = (value: string | boolean) => {
  if (typeof value === 'string') {
    return value;
  }
  if (value) {
    return copy.addonsAppDetail.included;
  }
  return copy.addonsAppDetail.notIncluded;
};

export const FeatureList: React.FC<Props> = ({ planFeatures }) => {
  const featureListElement = useMemo(
    () => (
      <>
        <Heading level="h2" scale="md" weight="bold">
          {copy.addonsAppDetail.planFeatures}
        </Heading>

        <FeatureListElement>
          {planFeatures.map(
            (
              { name, string_value: stringValue, boolean_value: booleanValue },
              j
            ) => {
              const isStringValue = typeof stringValue === 'string';
              const value = isStringValue ? stringValue : booleanValue;
              const displayValue = formatFeatureValues(value);

              return (
                <FeatureListItemWrapper
                  key={`${name}-${j}`}
                  $enabled={Boolean(value)}
                >
                  <FeatureListItem>
                    <Box mr={3}>
                      <FeatureListItemName id={name}>
                        {name}
                      </FeatureListItemName>
                    </Box>
                    <FeatureListItemValue aria-labelledby={name}>
                      {displayValue}
                    </FeatureListItemValue>
                  </FeatureListItem>
                </FeatureListItemWrapper>
              );
            }
          )}
        </FeatureListElement>
      </>
    ),
    [planFeatures]
  );

  return featureListElement;
};
